import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListBook = (props) => {
  const { attributes, actions, listBook, findAllBooks, totalPages, loading, query } = useForm(props.displayOptions);

  const { t, i18n } = useTranslation();

  const { displayOptions } = props;

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('book.title.list')} subtitle={t('book.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listBook}
                loading={loading}
                search={findAllBooks}
                numberOfPage={totalPages}
                query={query}
                // name={'book'}
                textButton={displayOptions.addButton && t('book.add')}
                linkButton={displayOptions.addButton && '/book/add'}
                name="booksList"
                pdfTitle="Liste des livres"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListBook;
